"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 14 13';

var Warning = function Warning() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M7.15865,9.57735 C6.78915,9.57735 6.48965,9.87685 6.48965,10.24635 C6.48965,10.61585 6.78915,10.91535 7.15865,10.91535 C7.52815,10.91535 7.82765,10.61585 7.82765,10.24635 C7.82765,9.87685 7.52815,9.57735 7.15865,9.57735"
  }), _react["default"].createElement("path", {
    d: "M1.3232,11.6306 L12.4787,11.6306 L6.9007,1.3351 L1.3232,11.6306 Z M12.5677,11.7951 L12.5697,11.7951 L12.5677,11.7951 Z M12.6657,12.7456 L1.1362,12.7456 C0.5832,12.7456 0.1322,12.2956 0.1322,11.7421 C0.1322,11.5761 0.1742,11.4111 0.2532,11.2646 L6.0187,0.6231 C6.2822,0.1361 6.8932,-0.0449 7.3787,0.2191 C7.5507,0.3116 7.6902,0.4516 7.7837,0.6231 L13.5482,11.2641 C13.8122,11.7501 13.6302,12.3606 13.1442,12.6241 C12.9972,12.7036 12.8322,12.7456 12.6657,12.7456 Z"
  }), _react["default"].createElement("path", {
    d: "M7.04735,8.6975 C6.73935,8.6975 6.48985,8.4475 6.48985,8.14 L6.48985,4.7695 C6.48985,4.461 6.73935,4.2115 7.04735,4.2115 C7.35485,4.2115 7.60485,4.461 7.60485,4.7695 L7.60485,8.14 C7.60485,8.4475 7.35485,8.6975 7.04735,8.6975"
  }));
};

var _default = (0, _createSvgIcon["default"])(Warning, {
  viewBox: viewBox
});

exports["default"] = _default;